var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"flat":"","hover":"","height":"200px","color":"transparent"}},[_c('v-layout',{attrs:{"align-center":"","justify-end":"","row":"","fill-height":""}},[_c('v-flex',{attrs:{"md12":"","text-md-center":""}},[_c('v-img',{attrs:{"src":_vm.section_image,"height":"200px","contain":""}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }